import { baseApi } from "./baseApi";

const DECONSOLIDATION_BASE_URL = "/deconsolidations";

export const deconsolidationApi = baseApi.injectEndpoints({
  tagTypes: ["Deconsolidation"],

  endpoints: (builder) => ({
    addDeconsolidation: builder.mutation({
      query: (payload) => ({
        url: DECONSOLIDATION_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Deconsolidation", id: _id },
        { type: "Deconsolidation", id: "LIST" },
      ],
    }),

    listDeconsolidation: builder.query({
      query: (params) => ({
        url: DECONSOLIDATION_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "Deconsolidation",
                id: _id,
              })),
              { type: "Deconsolidation", id: "LIST" },
            ]
          : [{ type: "Deconsolidation", id: "LIST" }],
    }),

    getDDLDeconsolidation: builder.query({
      query: (params) => ({
        url: `${DECONSOLIDATION_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "Deconsolidation",
                id: _id,
              })),
              { type: "Deconsolidation", id: "DDL" },
            ]
          : [{ type: "Deconsolidation", id: "DDL" }],
    }),

    getDeconsolidationDetail: builder.query({
      query: (id) => `${DECONSOLIDATION_BASE_URL}/${id}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "Deconsolidation", id: _id },
        { type: "Deconsolidation", id: "LIST" },
      ],
    }),

    updateDeconsolidation: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${DECONSOLIDATION_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "Deconsolidation", id },
        { type: "Deconsolidation", id: "LIST" },
      ],
    }),

    listShipmentsByDeconsolidationId: builder.query({
      query: ({ deconsolidationId, page, limit }) => ({
        url: `${DECONSOLIDATION_BASE_URL}/${deconsolidationId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Deconsolidation", id: _id },
        { type: "Deconsolidation", id: "LIST" },
    ],
    }),
     getDDLDeconsolidationShipments: builder.query({
      query: ({ account, entity }) => ({
        url: `${DECONSOLIDATION_BASE_URL}/ddl-deconsolidation`,
        params: { account, entity },
      }),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const {
  useAddDeconsolidationMutation,
  useListDeconsolidationQuery,
  useLazyListDeconsolidationQuery,
  useLazyGetDDLDeconsolidationQuery,
  useGetDeconsolidationDetailQuery,
  useUpdateDeconsolidationMutation,
  useLazyListShipmentsByDeconsolidationIdQuery,
  useLazyGetDDLDeconsolidationShipmentsQuery,
} = deconsolidationApi;
